import { Language, NotificationsNone, Settings } from "@material-ui/icons";
import React from "react";
import { Link } from "react-router-dom";
import "./topbar.css";

const Topbar = () => {
  return (
    <div className="topbar">
      <div className="topbar_wrapper">
        <div className="topbar_left">
          <Link to="/">
            <span className="logo">Jr Admin</span>
          </Link>
        </div>
        <div className="topbar_right">
          <div className="topbar_icon_container">
            <NotificationsNone />
            <span className="topbar_icon_badge">2</span>
          </div>
          <div className="topbar_icon_container">
            <Language />
            <span className="topbar_icon_badge">2</span>
          </div>
          <div className="topbar_icon_container">
            <Settings />
            <span className="topbar_icon_badge">2</span>
          </div>
          <img
            src="https://scontent.fbkk12-1.fna.fbcdn.net/v/t31.18172-8/13667897_1079533878796415_8638759316201616179_o.jpg?_nc_cat=106&ccb=1-5&_nc_sid=174925&_nc_ohc=wBQtjOlvkicAX-Y-cqD&_nc_ht=scontent.fbkk12-1.fna&oh=00_AT_FQtC4xtLk3yMvRGKoZnVdVtkKRK7WIq0YCUvROT9xGQ&oe=622FCC5E"
            alt=""
            className="topbar_avatar"
          />
        </div>
      </div>
    </div>
  );
};

export default Topbar;
